<table class="exercise-magic-box">
  <tr *ngFor="let row of exercise_body; let rowIndex = index">
    <td *ngFor="let elem of row; let elemIndex = index">
      <span *ngIf="elem">{{ elem }}</span>
      <span *ngIf="elem == null">
            <input
              type="text"
              class="magic_box_input"
              [class.error]="isCorrect(rowIndex, elemIndex, student_answer[rowIndex][elemIndex])"
              [disabled]="!isAuthorCard || !isAccessCard"
              #input
              (input)="inputEnter(rowIndex, elemIndex, input.value)"
              value="{{ student_answer[rowIndex][elemIndex] }}">
          </span>
    </td>
  </tr>
</table>
